import isEqual from "lodash/isEqual"
import { AppAssetsConfig, getSubAppsConfig } from "@/sub-apps"
import { IS_GREY } from "@/constants/environment"
import { createUpdatePrompt } from "@/components/update-prompt"

const getMetadata = (appsConfig: AppAssetsConfig[]) =>
  appsConfig.map(item => [
    item.assets.metadata.build.buildTime,
    item.assets.metadata.build.longCommit,
  ])

const diffVersion = (initAppsConfig: AppAssetsConfig[]) =>
  getSubAppsConfig().then(appsConfig => {
    const oldVersion = getMetadata(initAppsConfig)
    const newVersion = getMetadata(appsConfig)

    return !isEqual(oldVersion, newVersion)
  })

export const checkNewVersion = (initAppsConfig: AppAssetsConfig[]) => {
  const timer = setTimeout(() => {
    diffVersion(initAppsConfig)
      .then(newVersionAvailable => {
        // New version available alert
        return newVersionAvailable
          ? new Promise((resolve, reject) => {
              const prompt = createUpdatePrompt({
                onAccept() {
                  prompt.dismiss()
                  resolve(true)
                },
                onReject() {
                  prompt.dismiss()
                  reject(false)
                },
              })
            })
          : Promise.reject(false)
      })
      .then(() => {
        window.location.reload()
      })
      .catch(() => {
        clearInterval(timer)
        checkNewVersion(initAppsConfig)
      })
  }, (IS_GREY ? 48 : 24) * 60 * 60 * 1000)
}
